function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "StatusIcon To Engage",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.114 20.3c0 10.031 8.391 19.922 21.492 28.359a5.17 5.17 0 0 0 2.18.891 4.945 4.945 0 0 0 2.18-.891c13.1-8.437 21.492-18.328 21.492-28.359 0-8.6-5.93-14.6-13.617-14.6a11.832 11.832 0 0 0-10.055 5.156A11.8 11.8 0 0 0 18.731 5.7c-7.664 0-13.617 6-13.617 14.6zm4.734 0c0-5.953 3.891-9.961 9.141-9.961 4.242 0 6.609 2.578 8.086 4.828.656.937 1.1 1.242 1.711 1.242.633 0 1.008-.328 1.711-1.242 1.57-2.227 3.891-4.828 8.109-4.828 5.25 0 9.141 4.008 9.141 9.961 0 8.3-8.649 17.461-18.516 24.023a1.147 1.147 0 0 1-.445.234 1.149 1.149 0 0 1-.445-.234C18.474 37.763 9.849 28.6 9.849 20.3z",
    transform: "translate(2.886 4.966)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/heart-outline.76477734.svg";
export { ForwardRef as ReactComponent };